import { render, staticRenderFns } from "./HeadInfo.vue?vue&type=template&id=71b15992&scoped=true&"
import script from "./HeadInfo.vue?vue&type=script&lang=js&"
export * from "./HeadInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeadInfo.vue?vue&type=style&index=0&id=71b15992&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b15992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b15992')) {
      api.createRecord('71b15992', component.options)
    } else {
      api.reload('71b15992', component.options)
    }
    module.hot.accept("./HeadInfo.vue?vue&type=template&id=71b15992&scoped=true&", function () {
      api.rerender('71b15992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/HeadInfo.vue"
export default component.exports